import location from '~/plugins/LocationPlugin';
import API from '~/api';

export default function ({ store, redirect }) {
  if (!API.credentials.login) {
    location.redirect(`https://www.${process.env.WEB_DOMAIN}/login`);
    return;
  }

  if (!store.getters.getCurrentAgent?.id) {
    return;
  }

  redirect('/home');
}
